// Enunciados das perguntas de cada anamnese, por perfil do aluno.
// Gerado a partir das listas PERGUNTAS dos componentes em components/anamneses.
// O relatório usa este arquivo para exibir o texto da pergunta no lugar do id salvo.

export const PERGUNTAS_ANAMNESE = {
  homensEMulheresAdultos: [
    "1. Quais os seus objetivos com o programa de treinamento?",
    "2. Qual o seu condicionamento físico atual?",
    "3. Você treina a quanto tempo?",
    "4. Qual a sua disponibilidade para treinar?",
    "5. Quais dias você tem disponibilidade?",
    "6. Quais exercícios você pratica atualmente?",
    "7. Qual era a intensidade dos exercícios?",
    "8. Refeições realizadas normalmente:",
    "9. Realiza algum tipo de dieta?",
    "10. Utiliza algum suplemento alimentar?",
    "11. Já realizou algum teste de esforço?",
    "12. Você consome bebidas alcoólicas?",
    "13. Ingere líquidos com frequência?",
    "14. Você tem diabetes?",
    "15. Qual seu nível de glicemia em jejum?",
    "16. Qual seu nível de colesterol?",
    "17. Você fuma?",
    "18. Doenças ou queixas:",
    "19. Medicamentos:",
    "20. Lesões articulares/musculares?",
    "21. Histórico familiar:",
  ],
  mulheresQueDesejamEmagrecer: [
    "1. Quais os seus objetivos com o programa de treinamento?",
    "2. Como você classificaria sua autoestima hoje?",
    "3. Daqui a 6 meses, quais objetivos conquistados te deixariam mais feliz?",
    "4A. Qual silhueta melhor representa sua aparência física atual?",
    "4B. Qual silhueta você gostaria de ter (ideal)?",
    "5. Você já fez uso de remédios para emagrecer? (Se sim, especifique nomes e resultados)",
    "6. Qual é a sua maior dificuldade para conseguir emagrecer?",
    "7. Nos últimos 6 meses, o ciclo menstrual esteve regulado?",
    "8. Durante o período menstrual, quais sintomas você costuma sentir?",
    "9. Nos últimos 6 meses, você fez uso de anticoncepcional?",
    "10. Você tem alguma das condições abaixo?",
    "11. Praticou exercício nos últimos 6 meses? Se sim, qual?",
    "12. Quais fatores te impedem de manter a regularidade nos treinos?",
    "13. Qual sua disponibilidade (Dias na semana e minutos por dia)?",
    "14. Quais tipos de exercícios você GOSTA de fazer?",
    "15. Quais tipos de exercícios você NÃO GOSTA de fazer?",
    "16. Faz uso de algum remédio de forma crônica (todo dia)?",
    "17. Teve dor em alguma região nos últimos 7 dias? (Informe a região e nota de 0 a 10)",
    "18. Algo relevante sobre sua saúde ou rotina para o programa de exercícios?",
  ],
  idosos: [
    "1. Daqui a 3 meses, o que você mais quer como benefício do treino?",
    "2. Sente alguma dor no corpo NESSE MOMENTO? Se sim, em qual região?",
    "3. Nos últimos 30 dias, sentiu alguma dor ou desconforto? Se sim, onde?",
    "4. Você tem dificuldade em realizar estas atividades EM CASA ou no quintal?",
    "5. Você tem dificuldade em realizar estas atividades NA RUA (fora de casa)?",
    "6. Você tem conhecimento ou diagnóstico médico de alguma destas condições?",
    "7. Você sente fraqueza nas pernas quando vai caminhar ou subir escadas?",
    "8. Toma remédio todos os dias? Se sim, assinale o motivo abaixo:",
    "9. Alguma vez ao caminhar, você perdeu o equilíbrio e caiu?",
    "10. Já realizou alguma cirurgia? Se sim, assinale a região abaixo:",
    "11. O que te deixaria mais feliz conseguir fazer sem dor ou cansaço?",
    "12. O que mais te incomoda HOJE?",
  ],
  gestantes: [
    "1. Essa é sua primeira gestação? (Se não, quantas anteriores?)",
    "2. Qual é a data prevista para o parto?",
    "3. Tem hipertensão induzida pela gravidez ou pré-eclâmpsia?",
    "4. Tem conhecimento de alguma complicação na gestação?",
    "5. Assinale caso tenha sentido algum destes sintomas:",
    "6. Tem diabetes induzida pela gravidez?",
    "7. O médico recomendou NÃO praticar algum exercício? Por quê?",
    "8. Você já recebeu diagnóstico médico de alguma destas doenças?",
    "9. Antes da gestação, você praticava atividade física?",
    "10/11. Atividades anteriores (Tipo, Frequência, Tempo e Intensidade):",
    "12. Atualmente, o que você tem dificuldade para realizar?",
    "13. Nos últimos 7 dias, sentiu dor em alguma destas regiões?",
    "14. Dê uma nota de 0 a 10 para as dores relatadas:",
    "15. Informações adicionais relevantes para o seu treino:",
  ],
  posParto: [
    "1. Essa é sua primeira gestação? (Se não, informe o número de gestações anteriores)",
    "2. Qual foi a data do parto?",
    "3. Qual foi o tipo de parto?",
    "4. Houve alguma intercorrência durante o parto? (Se sim, descreva em detalhes)",
    "5. Após o parto, houve alguma intercorrência? (Se sim, descreva em detalhes)",
    "6. Qual foi o peso ganho na gravidez?",
    "7. Durante a gestação, houve hipertensão induzida pela gravidez ou pré-eclâmpsia (principalmente após o 5° mês)?",
    "8. Fez uso de fármacos para controlar a hipertensão induzida pela gravidez ou pré-eclâmpsia? (Se sim, informe o nome)",
    "9. Durante a gestação, houve aumento da glicemia que caracterizou a presença de diabetes gestacional?",
    "10. Fez uso de fármacos ou insulina para controlar o diabetes gestacional? (Se sim, informe quais)",
    "11. Após a gestação, quantos quilos de peso você já perdeu?",
    "12. Pensando na percepção da sua autoestima hoje, assinale as afirmações com as quais você se identifica:",
    "13. Hoje, qual é a parte do seu corpo que mais te incomoda?",
    "14. Você já recebeu diagnóstico médico de alguma doença?",
    "15. Antes ou durante a gestação, você estava praticando alguma atividade física?",
    "16. Se respondeu SIM na anterior, detalhe as atividades, frequência, tempo e intensidade:",
    "17. Nos últimos 7 dias, você sentiu alguma dor no corpo? Se sim, selecione as regiões:",
    "18. Para as regiões que marcou dor, informe a região e a nota de 0 (Nenhuma) a 10 (Insuportável):",
    "19. Quais são seus objetivos com o programa de exercício físico?",
    "20. Se imagine daqui a 6 meses. Descreva como gostaria de estar, pensando no seu corpo e na sua saúde:",
  ],
  obesos: [
    "1. Quando você começou a ganhar peso? Por favor, seja específico (ano, contexto, se foi por conta de algum trauma):",
    "2. Qual o peso máximo que você atingiu na vida?",
    "3. Quantas vezes já fez algo para emagrecer (dietas, exercício, remédios, cirurgias)?",
    "4. O que você fez para emagrecer e que deu certo?",
    "5. O que você fez para emagrecer e que deu errado?",
    "6. Quais são os seus objetivos com o programa de treinamento?",
    "7. Qual sua disponibilidade para treinar (Dias na semana e minutos por dia)?",
    "8. Quais são os tipos de exercícios físicos que você GOSTA de fazer?",
    "9. Quais são os tipos de exercícios físicos que você NÃO GOSTA de fazer?",
    "10. Você tem algumas das doenças ou condições listadas abaixo que foi diagnosticada por um médico?",
    "11. Você já fez uso de algum medicamento para emagrecer? (Se sim, informe o nome e quantos kg perdeu)",
    "12. Atualmente, você está fazendo uso de algum remédio de forma crônica (uso todos os dias)? Se sim, liste-os:",
    "13. Nos últimos 15 dias, você sentiu alguma dor no corpo?",
    "14. Nos últimos 15 dias, você sentiu dor nos ossos, músculos, articulações ou em qualquer parte do corpo no REPOUSO?",
    "15. Assinale os descritores que caracterizam a sua dor mais importante quando você está em REPOUSO:",
    "16. Informe as regiões do corpo onde você sente dor DURANTE O EXERCÍCIO FÍSICO e suas respectivas notas de 0 a 10:",
    "17. Assinale os descritores que caracterizam a sua dor mais importante DURANTE O EXERCÍCIO FÍSICO:",
    "18. As dores corporais que sente quando está em EXERCÍCIO FÍSICO te impedem de fazer atividades simples do dia a dia? (Se sim, quais?)",
    "19. Na sua percepção, as dores corporais estão prejudicando os movimentos que você faz quando está em ESFORÇO? (Se sim, quais?)",
    "20. Você faz exame de sangue pelo menos uma vez ao ano?",
    "21. Considerando o último exame de sangue realizado, você apresenta alguma das condições abaixo?",
    "22. Considerando um dia comum de semana, quantas horas por dia você dorme?",
    "23. Você acorda cansado?",
    "24. Dê uma nota de 0 a 10 para a qualidade do seu sono (reparação):",
    "25. Espaço destinado para escrever qualquer observação relevante que você julgue necessária para o treinador:",
  ],
  diabetesMelitus: [
    "1. Qual é o tipo de Diabetes Mellitus que você tem?",
    "2. Há quanto tempo você sabe que é portador(a) de Diabetes Mellitus?",
    "3. Atualmente, você faz acompanhamento nutricional com nutricionista para controlar o Diabetes Mellitus?",
    "4. Atualmente, você faz uso de fármacos para controlar o Diabetes Mellitus?",
    "5. Se faz uso de fármacos, quais são eles e a dosagem diária utilizada?",
    "6. Considerando o último exame de sangue realizado, qual foi o valor da hemoglobina glicada?",
    "7. Você tem conhecimento ou o médico já diagnosticou alguma das doenças abaixo?",
    "8. Você já teve alguma complicação crônica em função do Diabetes Mellitus?",
    "9. Você já teve crises de hiperglicemia? (Se sim, por favor, descreva o que sentiu)",
    "10. Você já teve crises de hipoglicemia? (Se sim, por favor, descreva o que sentiu)",
    "11. Quais são seus objetivos com o programa de treinamento?",
    "12A. Atualmente, você faz algum tipo de exercício físico?",
    "12B. Se respondeu SIM na anterior, qual exercício, frequência, tempo e intensidade você pratica?",
    "13. Alguma vez, durante a prática de exercício físico, sentiu alguns dos sintomas listados abaixo?",
    "14. Você faz quantas refeições por dia?",
    "15. Nos últimos 30 dias, você teve problemas para controlar a glicemia? Se sim, quantas vezes?",
    "16. Você faz o monitoramento diário da glicemia? Se sim, selecione o método utilizado:",
    "17. Quanto tempo faz da sua última visita ao médico para controle do Diabetes Mellitus?",
    "18. Caso queira relatar algo que julgue importante e que pode ajudar na elaboração do treino, escreva abaixo:",
  ],
  hipertensaoArterial: [
    "1. Há quanto tempo você foi diagnosticado com Hipertensão Arterial?",
    "2. Atualmente, você faz uso regular de algum fármaco para controle da Hipertensão Arterial? Se sim, selecione quais:",
    "3. Além de Hipertensão Arterial é de seu conhecimento o diagnóstico de outra doença?",
    "4. Você tem parentes de primeiro grau com diagnóstico de doenças cardiovasculares? (Se sim, informe o parentesco e a doença)",
    "5. Quando foi sua última visita ao médico para controle da Hipertensão Arterial?",
    "6. Quantas horas por noite você dorme?",
    "7. Como você classificaria a qualidade do seu sono?",
    "8. Algum parente já te disse que você ronca quando dorme?",
    "9. Você acorda se sentindo cansado(a)?",
    "10. Dê uma nota de 0 a 10 para sua memória:",
    "11. Nos últimos 30 dias teve algum episódio de esquecimento?",
    "12. Atualmente, você faz algum tipo de atividade física?",
    "13. Se respondeu SIM na anterior, qual exercício, frequência, tempo e intensidade você pratica?",
    "14. Durante a prática de atividade física, quais dos sintomas abaixo você já sentiu?",
    "15. Após o término da atividade física, quais dos sintomas abaixo você já sentiu?",
    "16. Quais seus objetivos com o programa de treinamento?",
  ],
  depressao: [
    "1. Quanto tempo faz que você soube que tinha Depressão?",
    "2. Atualmente, você faz uso de algum fármaco para controlar os sintomas? (Se sim, informe os nomes)",
    "3. Dê uma nota de 0 a 10 para sua autoestima hoje:",
    "4. Atualmente, é de seu conhecimento ter algum outro problema de saúde?",
    "5. Você apresenta algum dos seguintes sintomas listados abaixo?",
    "6. Como você classificaria a qualidade do seu sono? Dê uma nota de 0 a 10:",
    "7. Quantas horas por noite você dorme?",
    "8. Ao acordar, qual a sensação que você tem?",
    "9A. Atualmente, você faz algum tipo de exercício físico?",
    "9B. Se respondeu SIM na anterior, qual exercício, frequência, tempo e intensidade você pratica?",
    "10. Alguma vez, durante a prática de exercício físico, sentiu alguns dos sintomas listados abaixo?",
    "11. Quais são seus objetivos com o programa de treinamento?",
    "12. Quanto tempo faz da sua última visita ao médico para controle da Depressão?",
    "13. Quais são os tipos de exercícios físicos que você GOSTA de fazer?",
    "14. Quais são os tipos de exercícios físicos que você NÃO GOSTA de fazer?",
    "15. Você gosta de ouvir música? (Se sim, descreva até 5 músicas ou cantores favoritos)",
    "16. Nos últimos 7 dias, você sentiu alguma dor no corpo? Se sim, selecione as regiões:",
    "17. Algo relevante sobre sua saúde ou rotina que julgue importante para a elaboração do treino?",
  ],
};

export default PERGUNTAS_ANAMNESE;
